import { type RouteRecordRaw } from "vue-router";
import { canAccess, permissionList } from "@/utilities/authorization";

const stockRoutes: RouteRecordRaw[] = [
    {
        name: 'stock-input',
        path: '/stock/input',
        component: () => import('@/views/stock/InputStock.vue'),
        beforeEnter: () => canAccess(permissionList.INSERT_STOCK) ? true : { name: 'product-navigation' }
    },
    {
        name: 'stock-log',
        path: '/stock/log',
        component: () => import('@/views/stock/StockLog.vue'),
        beforeEnter: () => canAccess(permissionList.READ_STOCK_LOG) ? true : { name: 'product-navigation' }
    },
    {
        name: 'stock-log-detail',
        path: '/stock/log/:id(\\d+)',
        component: () => import('@/views/stock/StockLogDetail.vue'),
        beforeEnter: () => canAccess(permissionList.READ_STOCK_LOG) ? true : { name: 'product-navigation' }
    },
]

export default stockRoutes
